import { Spin, Table } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Screen } from '../../components';
import { getColumns } from './constants';
import { useGetOppositionBases } from '../../services/oppositionBase';
import { ManageOppositionBases, RemoveOppositionBases } from './components/modal/ManageOppositionBases';
import { useCallback, useState } from 'react';
import { type TOppositionBase } from '../../types/oppositionBase';

const AdminOppositionBasesPage = () => {
  const [openManage, setOpenManage] = useState<boolean>(false);
  const [openRemove, setOpenRemove] = useState<boolean>(false);
  const [selectedBase, setSelectedBase] = useState<TOppositionBase | undefined>(undefined);
  const { loading, oppositionBases, refetch } = useGetOppositionBases();

  const openCreate = useCallback(() => {
    setSelectedBase(undefined);
    setOpenManage(true);
  }, []);

  const closeManage = async () => {
    setOpenManage(false);
    setSelectedBase(undefined);
    await refetch();
  };

  const closeRemove = async () => {
    setOpenRemove(false);
    setSelectedBase(undefined);
    await refetch();
  };

  const editBase = (base: TOppositionBase) => {
    setSelectedBase(base);
    setOpenManage(true);
  };

  const removeBase = (base: TOppositionBase) => {
    setSelectedBase(base);
    setOpenRemove(true);
  };

  const columns = getColumns({ onEdit: editBase, onRemove: removeBase });

  return (
    <Screen id="OppositionBases" title="Bases de la oposición" actions={[{ icon: <PlusOutlined />, onClick: openCreate }]}>
      {loading && <Spin tip="Loading" size="large" />}
      {!loading && (
        <Table
          locale={{ emptyText: 'No hay bases que mostrar' }}
          columns={columns}
          dataSource={oppositionBases}
          rowKey="_id"
        />
      )}

      <ManageOppositionBases
        isOpen={openManage}
        onCancel={closeManage}
        title={`${selectedBase ? 'Actualizar' : 'Crear'} bases`}
        oppositionBase={selectedBase}
      />
      <RemoveOppositionBases isOpen={openRemove} onCancel={closeRemove} oppositionBase={selectedBase} />
    </Screen>
  );
};

export { AdminOppositionBasesPage };
